document.addEventListener('DOMContentLoaded', () => {

  const cards = document.querySelectorAll('.faq-category-card');
  const sections = document.querySelectorAll('.faq-section');

  if (!cards.length || !sections.length) return;

  // Alle ausblenden außer die erste
  sections.forEach((section, index) => {
    section.style.display = index === 0 ? 'block' : 'none';
  });

  cards.forEach((card, index) => {

    card.addEventListener('click', () => {

      cards.forEach(c => c.classList.remove('active'));
      card.classList.add('active');

      sections.forEach(section => {
        section.style.display = 'none';
      });

      const target = document.getElementById(
        card.dataset.target
      );

      if (target) {
        target.style.display = 'block';

        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }

    });

  });

});